import React from "react";
import { component_tool } from "@/tool";
import BatchInput from "./batchInput";
import { WizTableForm } from "@/containers/common";
import TextArea from "antd/lib/input/TextArea";
const organizationConfig = WizTableForm.Config.organization(this, {
  apiParams: { state: 1 },
});
const positionConfig = WizTableForm.Config.position(this, {
  apiParams: { state: 1 },
});
let { WizModal } = component_tool;

//配置项
const componentName = "classResult";
let ref;
let refi;
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden",
    },
  },
  {
    title: "姓名",
    name: "fullName",
    dataIndex: "fullName",
    searchItem: {},
    tableItem: {},
    formItem: {},
  },
  {
    title: "账号",
    name: "userName",
    dataIndex: "userName",
    searchItem: {},
    tableItem: {},
    formItem: {},
  },
  {
    title: "手机号",
    name: "mobile",
    tableItem: {},
  },
  // {
  //   title: '身份证号',
  //   name: 'idCard',
  //   tableItem: {}
  // },
  // {
  //   title: '用户属性',
  //   name: 'userType',
  //   tableItem: {},
  //   dict: [
  //     { code: 0, codeName: "学员" },
  //     { code: 1, codeName: "SGM总部" },
  //     { code: 2, codeName: "SGM区域" },
  //     { code: 3, codeName: "供应商" }
  //   ]
  // },
  {
    title: "组织名称",
    name: "orgIds",
    searchItem: {
      diy: WizTableForm,
      ...organizationConfig,
    },
  },
  {
    title: "岗位",
    name: "positionIds",
    searchItem: {
      diy: WizTableForm,
      ...positionConfig,
    },
  },

  {
    title: "组织名称",
    name: "orgName",
    tableItem: {
      width: 150,
    },
  },
  {
    title: "组织编码",
    name: "orgCode",
    tableItem: {
      width: 120,
    },
  },
  {
    title: "岗位",
    name: "positionName",
    tableItem: {
      width: 100,
    },
  },
  {
    title: "任职状态",
    name: "jobState",
    dict: [
      { code: 0, codeName: "离职" },
      { code: 1, codeName: "在职" },
    ],
    tableItem: {
      width: 100,
    },
  },
  {
    title: "成绩",
    name: "score",
    tableItem: {
      render: (text, record) => {
        let scoreVal = "";
        if (record.status != 0 && record.status != 3) {
          scoreVal = record.score;
        }
        return scoreVal;
      },
    },
    formItem: {
      render: (text, record) => { },
    },
  },
  {
    title: "通过状态",
    name: "status",
    tableItem: {},
    dict: [
      { code: 1, codeName: "通过" },
      { code: 2, codeName: "未通过" },
      { code: 3, codeName: "无成绩" },
    ],
    formItem: {
      type: "radio",
      initialValue: 0,
    },
    searchItem: {
      type: "select",
    },
  },
  {
    title: "是否请假",
    name: "leaveState",
    dict: [
      { code: 0, codeName: "否" },
      { code: 1, codeName: "是" },
    ],
    tableItem: {},
    searchItem: {
      type: "select",
    },
  },
  {
    title: "是否已联系",
    name: "yuntelState",
    dataIndex: "yuntelState",
    formItem: {},
    tableItem: {},
    searchItem: {
      type: "select",
    },
    dict: [
      { code: 0, codeName: "未联系" },
      { code: 1, codeName: "已联系" },
    ],
  },
  // {
  //   title: '评语',
  //   name: 'comment',
  //   tableItem: {
  //     width: 200,
  //   },
  //   formItem: {}
  // }
];

const templateConfig = (date) => {
  const { onSelect, classInfoId, _btnLookUserFun, _this } = date;
  let _onSelect = (key, rows) => {
    onSelect && onSelect(key, rows);
    ref && ref.getSelectRows(rows);
  };
  let initRows = () => {
    return _this.state.selectedClassResultRows;
  };
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          buttonSort: ["batchInput", "batchImport", "export", 'callLog'],
          buttons: [
            {
              key: "batchInput",
              custom: true,
              needSelect: true,
              params: { children: "批量输入", type: "info" },
              customOnClick: {
                key: "modal",
                params: {
                  modalKey: new Date().getTime(),
                  modalParams: {
                    title: "批量输入",
                    diy: (e) => {
                      e.record = Object.assign({}, e.record);
                      return (
                        <BatchInput
                          {...e}
                          key={"Input" + e.record.id}
                          initRows={initRows}
                          ref={(r) => {
                            ref = r && r.getWrappedInstance();
                          }}
                          timeStamp={new Date().getTime()}
                          classInfoId={classInfoId}
                          personId={e.record.personId}
                        />
                      );
                    },
                    onOk: () => {
                      ref._ok();
                    },
                    onCancel: () => {
                      ref._doInitParams();
                    },
                    width: 600,
                  },
                },
              },
            },
            {
              key: "batchImport",
              custom: true,
              params: { icon: "export", children: "批量导入", type: "export" },
              customOnClick: {
                key: "jumpPage",
                params: {
                  key: "push",
                  pathname: "/face/classList/classResult/classResultFileImport",
                  record: { classInfoId: classInfoId },
                },
              },
            },
            {
              key: "export",
              custom: true,
              params: { icon: "export", children: "导出", type: "export" },
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "export",
                  apiParams: {},
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters };
                },
              },
            },
            {
              key: 'callLog',
              name: 'WizButton',
              params: {
                children: '通话记录',
                key: 'callLog',
              },
             onClick: (e) => { _this.openCallLog && _this.openCallLog() }
            },
          ],
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false,
          onSelect: _onSelect,
        },
        commonOperate: {
          //   add: true,
          //   delete: true
          //update: true
        },
        rowOperateSort: ["enterGrade", "showUserIdentity", "viewComments", 'phoneCall', 'callLog'],
        rowOperateView: [
          {
            key: "enterGrade",
            custom: true,
            params: { children: "输入成绩" },
            customOnClick: {
              key: "modal",
              params: {
                modalKey: new Date().getTime(),
                modalParams: {
                  title: "输入成绩",
                  diy: (e) => {
                    e.record = Object.assign({}, e.record);
                    return (
                      <BatchInput
                        {...e}
                        key={"BatchInput" + e.record.id + new Date().getTime()}
                        initRows={initRows}
                        ref={(r) => {
                          refi = r && r.getWrappedInstance();
                        }}
                        timeStamp={new Date().getTime()}
                        classInfoId={classInfoId}
                        personId={e.record.personId}
                        alone={true}
                      />
                    );
                  },
                  onOk: () => {
                    refi._ok();
                  },
                  onCancel: () => {
                    refi._doInitParams();
                  },
                  width: 600,
                },
              },
              formatParams: (rows, record, filter) => {
                return { ...record };
              },
            },
            recordChangeParams: ({ record, rows }) => {
              return { disabled: record.leaveState === 1 };
            },
          },
          // {
          //   key: "showUserIdentity",
          //   name: "WizButton",
          //   params: {  children: "查看已选任职",
          //     key: "_btn",
          //   },
          //   onClick: e => _btnLookUserFun && _btnLookUserFun(e),
          // },
          {
            key: "viewComments",
            custom: true,
            params: { children: "查看评语" },
            customOnClick: {
              key: "modal",
              params: {
                modalKey: "comment" + new Date().getTime(),
                modalParams: {
                  title: "查看评语",
                  diy: (e) => {
                    e.record = Object.assign({}, e.record);
                    return (
                      // <TextArea disabled={true} value={e.record.comment}></TextArea>
                      <div>{e.record.comment}</div>
                    );
                  },
                  footer: null,
                  width: 600,
                },
              },
              formatParams: (rows, record, filter) => {
                return { ...record };
              },
            },
          },
          {
            key: 'phoneCall',
            name: 'WizButton',
            params: {
              children: '拨打电话',
              key: 'phoneCall',
            },
            onClick: (e) => { _this.openCall && _this.openCall(e['record']) }
          },
          {
            key: 'callLog',
            name: 'WizButton',
            params: {
              children: '通话记录',
              key: 'callLog',
            },
            onClick: (e) => { _this.openCallLog && _this.openCallLog(e['record']) }
          },
        ],
      },
    },
  };
};

let reduxTemplateCofig = (p, args) => {
  const { classInfoId } = args;
  const apis = {
    list: {
      path: `${componentName}/getListByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: { classInfoId: classInfoId },
      },
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: {},
      },
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
        apiParams: {},
      },
    },
    update: {
      path: `${componentName}/update`,
      payload: {
        key: `${componentName}@update`,
        apiParams: {},
      },
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: { classInfoId: classInfoId },
      },
    },
  };

  return {
    apis,
    componentName,
    initApiKeys: ["list"],
    keepInitApiParams: true,
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
